'use strict';

exports.__esModule = true;
exports.default = SendToMessenger;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _MessengerSize = require('./constants/MessengerSize');

var _MessengerSize2 = _interopRequireDefault(_MessengerSize);

var _MessengerColor = require('./constants/MessengerColor');

var _MessengerColor2 = _interopRequireDefault(_MessengerColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SendToMessenger(props) {
  var className = props.className,
      color = props.color,
      messengerAppId = props.messengerAppId,
      pageId = props.pageId,
      children = props.children,
      dataRef = props.dataRef,
      size = props.size,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-send-to-messenger',
        messenger_app_id: messengerAppId,
        page_id: pageId,
        'data-color': color,
        'data-size': size,
        'data-ref': dataRef
      },
      children
    )
  );
}

SendToMessenger.defaultProps = {
  color: undefined,
  size: undefined,
  dataRef: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=SendToMessenger.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/SendToMessenger.js
// module id = 1021
// module chunks = 198517197184460